import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import Commons from './controls/Commons';
import { clearListAllAdministrativeServicesData } from "src/redux/administrativeService/administrativeServiceActions";
import ExpedienteContainer from './controls/ExpedienteContainer';
import { clearNewAffectationAdministrativeDocumentData } from 'src/redux/affectation/affectationActions';
import { clearListOrderPayLast } from 'src/redux/orderPay/orderPayActions';
import { Alert, Button, Card, Col, Form, Row, Spinner, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAsterisk, faTimes, faPlus, faUserPlus, faUsers } from "@fortawesome/free-solid-svg-icons";
import { NumericFormat } from "react-number-format";
import { getMsjAFIP, onKeyDownEnter } from "src/utils/utils";
import FormFieldError from "src/components/general/FormFieldError";
import { getCuitDataIsFetching } from "src/redux/user/userReducer";
import { tryGetPersonaNameByCuit } from "src/redux/user/userActionCreator";
import { isNotEmptyArray } from 'src/services/validationService';
import BeneficiariesAmountValidationComponent from './controls/BenefiariesAmountValidationComponent';

const SubsidiesForm = () => {
    const dispatch = useDispatch();
    const { orderPay, register, errors, setValue, clearErrors, formValuesState, setFormValuesState } = useFormContext();
    const [administrativeDocument, setAdministrativeDocument] = useState([]);
    const [admServiceId, setAdmServiceId] = useState('');
    const { fundRequest, expedientesAsociados, setExpedientesAsociados, administrativeServiceData, expedientesSeleccionados, importe, amountsShowValidation } = useFormContext();

    //CUIT
    const cuitDataIsFetching = useSelector(state => getCuitDataIsFetching(state));

    const [removeState, setRemoveState] = useState(false);
    const [validarPersona, setValidarPersona] = useState(false);
    const [validatedPerson, setValidatedPerson] = useState(false);
    const [msjValidacionColor, setMsjValidacionColor] = useState('success');
    const [msjValidacion, setMsjValidacion] = useState('');
    const [personaFound, setPersonaFound] = useState(false);
    const [cuitValue, setCuitValue] = useState("");
    const [companyNameValue, setCompanyNameValue] = useState("");
    const [amountValue, setAmountValue] = useState("");
    const [beneficiaryValidator, setBeneficiaryValidator] = useState('');
    const [providerNumber, setProviderNumber] = useState('');

    // New state for multiple beneficiaries
    const _beneficiaries = [];
    const [beneficiaries, setBeneficiaries] = useState(_beneficiaries);
    const [currentBeneficiaryData, setCurrentBeneficiaryData] = useState(null);

    const totalAmountBeneficiaries = isNotEmptyArray(beneficiaries)
        ? beneficiaries.reduce((sum, b) => sum + (b?.subsidyAmount || 0), 0)
        : 0;
    const selectedExpedientAssociated = expedientesAsociados?.filter(i => i.selected);

    const isValidTotalAmountBeneficiaries = amountsShowValidation(totalAmountBeneficiaries, importe);

    const applyFilterBankAccounts = (administrativeServiceId) => {
        setAdmServiceId(administrativeServiceId);
    };

    // Form data
    const liquidationValidationObj = { required: false };
    const correspondToValidationObj = { required: 'Campo requerido.' };

    const clearBeneficiarioForm = () => {
        setCuitValue("");
        setCompanyNameValue("");
        setAmountValue("");
        setRemoveState(false);
        setValidarPersona(false);
        setValidatedPerson(false);
        setPersonaFound(false);
        setBeneficiaryValidator('');
        setProviderNumber('');
        setCurrentBeneficiaryData(null);
        clearErrors(['cuit', 'companyName', 'amount']);
    };

    const handleInputChange = (value) => {
        let cuit = value.replace(/-/g, "")
        let newCuit = cuit.replace(/X/g, "");
        setCuitValue(value);
        delete errors?.cuit;
        if (newCuit.length === 11 && !cuitDataIsFetching) {
            dispatch(tryGetPersonaNameByCuit(newCuit)).then((response) => {
                const responseData = JSON.parse(response?.data || '{}');
                const acreedor = {
                    cuit: newCuit,
                    id: responseData?.id,
                    companyName: responseData?.companyName,
                    beneficiaryValidator: responseData?.beneficiaryValidator,
                    providerNumber: responseData?.providerNumber
                };
                acreedor?.beneficiaryValidator ? setMsjValidacionColor('success') : setMsjValidacionColor('warning');
                acreedor?.beneficiaryValidator ? setValidatedPerson(true) : setValidatedPerson(false);
                acreedor?.companyName && delete errors?.companyName;
                acreedor?.id ? setValidarPersona(false) : setValidarPersona(true);
                setMsjValidacion(getMsjAFIP(acreedor?.beneficiaryValidator, acreedor?.providerNumber));
                setProviderNumber(acreedor?.providerNumber || '');
                setBeneficiaryValidator(acreedor?.beneficiaryValidator || '');

                setCurrentBeneficiaryData(acreedor);

                if (acreedor?.companyName) {
                    setCompanyNameValue(acreedor.companyName);
                    setPersonaFound(true);
                } else {
                    setPersonaFound(false);
                }
            });
        }
    };

    const handleInputProveedor = (event) => {
        setCompanyNameValue(event.target.value);
    };

    const addBeneficiary = () => {
        // Validate before adding
        if (!cuitValue || cuitValue.replace(/-/g, "").replace(/X/g, "").length !== 11) {
            setValue('cuit', '');
            return;
        }

        if (!companyNameValue) {
            setValue('companyName', '');
            return;
        }

        if (!amountValue || parseFloat(amountValue.replace(/\$/g, '').replace(/\./g, '').replace(',', '.')) <= 0) {
            setValue('amount', '');
            return;
        }

        // Check if CUIT already exists
        const cuitClean = cuitValue.replace(/-/g, "").replace(/X/g, "");
        if (beneficiaries.some(b => b.cuit === cuitClean)) {
            alert('Este CUIT ya fue agregado a la lista de beneficiarios.');
            return;
        }

        const cleanAmount = amountValue.replace(/\$/g, '').replace(/\./g, '').replace(',', '.').trim();
        const numericAmount = parseFloat(cleanAmount);

        const newBeneficiary = {
            cuit: cuitClean,
            cuitFormatted: cuitValue,
            companyName: companyNameValue,
            beneficiaryValidator: beneficiaryValidator,
            providerNumber: providerNumber,
            validatedPerson: validatedPerson,
            subsidyAmount: numericAmount,
            amountFormatted: amountValue
        };

        const updatedBeneficiaries = [...beneficiaries, newBeneficiary];

        setBeneficiaries(updatedBeneficiaries);

        setValue('beneficiaries', updatedBeneficiaries);

        setFormValuesState(prev => ({
            ...prev,
            beneficiaries: [{
                type: 'SUBSIDIO',
                receipts: updatedBeneficiaries
            }]
        }));

        clearErrors(['cuit', 'companyName', 'amount']);

        clearBeneficiarioForm();
    };

    const removeBeneficiary = (index) => {
        const updatedBeneficiaries = beneficiaries.filter((_, i) => i !== index);
        setBeneficiaries(updatedBeneficiaries);
        setValue('beneficiaries', updatedBeneficiaries);
        setFormValuesState(prev => ({
            ...prev,
            beneficiaries: updatedBeneficiaries.length > 0 ? [{
                type: 'SUBSIDIO',
                receipts: updatedBeneficiaries
            }] : []
        }));
    };

    useEffect(() => {
        if (orderPay) {
            setAdmServiceId(orderPay?.administrativeServiceId);
        }
        if (fundRequest) {
            setAdmServiceId(fundRequest.administrativeServiceId);
        }
        dispatch(clearListOrderPayLast());
        dispatch(clearListAllAdministrativeServicesData());
        dispatch(clearNewAffectationAdministrativeDocumentData());

        register('beneficiaries', {
            validate: value => value && value.length > 0 || 'Debe agregar al menos un beneficiario'
        });
        register('cuit');
        register('companyName');
        register('amount');

    }, []);

    useEffect(() => {
        if (orderPay?.id) {
            orderPay?.beneficiaries?.map(beneficiarie => {
                let benefeciarieCuit = {
                    cuit: beneficiarie?.persona?.cuit,
                    cuitFormatted: beneficiarie?.persona?.cuit,
                    subsidyAmount: beneficiarie?.subsidyAmount,
                    validatedPerson: '',
                    amountFormatted: "$ " + beneficiarie?.subsidyAmount?.toString()?.replace('.', ','),
                    beneficiaryValidator: beneficiarie?.persona?.beneficiaryValidator || '',
                    companyName: beneficiarie?.persona?.companyName || '',
                };
                _beneficiaries.push(benefeciarieCuit);
            });
        }
        setValue('beneficiaries', _beneficiaries || []);
        setFormValuesState({
            ...formValuesState,
            beneficiaries: [{
                type: 'SUBSIDIO',
                receipts: _beneficiaries
            }]
        });
    }, [orderPay]);

    return <>
        <Commons
            administrativeServiceData={administrativeServiceData}
            admServiceId={admServiceId}
            setAdmServiceId={setAdmServiceId}
            applyFilterBankAccounts={applyFilterBankAccounts}
            disabledImporte={true}
        />

        <Form.Group as={Row}>
            <Form.Label htmlFor='asunto' className='text-right d-flex mandatory-label' column sm='4'>
                Liquidación:
            </Form.Label>
            <Col sm='4'>
                <Form.Control
                    type='text'
                    name='settlement'
                    placeholder='Ingresar Liquidación'
                    ref={register(liquidationValidationObj)}
                    defaultValue={orderPay?.settlement}
                    maxLength="255"
                    onKeyDown={event => onKeyDownEnter(event)}
                />
                <FormFieldError errors={errors?.settlement} />
            </Col>
        </Form.Group>

        <Form.Group as={Row}>
            <Form.Label htmlFor='asunto' className='text-right d-flex mandatory-label' column sm='4'>
                <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
                Corresponde a:
            </Form.Label>
            <Col sm='4'>
                <Form.Control
                    as='textarea'
                    name='pertainsTo'
                    placeholder='Ingresar texto'
                    rows={4}
                    ref={register(correspondToValidationObj)}
                    defaultValue={orderPay?.pertainsTo}
                    maxLength="1000"
                    onKeyDown={event => onKeyDownEnter(event)}
                />
                <FormFieldError errors={errors?.pertainsTo} />
            </Col>
        </Form.Group>

        <br></br>
        {
            admServiceId &&
            <ExpedienteContainer
                expedientesAsociados={expedientesAsociados}
                setExpedientesAsociados={setExpedientesAsociados}
                administrativeDocument={administrativeDocument}
                setAdministrativeDocument={setAdministrativeDocument}
                showSubpartItemSelector={true}
            />
        }
        <br></br>

        <Card className="mb-3">
            <Card.Header>
                <FontAwesomeIcon icon={faUserPlus} className="mr-2" />
                Agregar Beneficiario
            </Card.Header>
            <Card.Body>
                <Form.Group as={Row}>
                    <Form.Label className='text-right d-flex mandatory-label' column sm='4'>
                        <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
                        CUIT:
                    </Form.Label>
                    <Col sm='4'>
                        <NumericFormat
                            className="form-control"
                            autoComplete="off"
                            type='text'
                            placeholder='CUIT'
                            value={cuitValue}
                            disabled={cuitDataIsFetching}
                            onChange={(event) => handleInputChange(event?.target?.value)}
                            format="##-########-#"
                            mask="X"
                            pattern="\b(20|23|24|27|30|33|34)(\D)?[0-9]{8}(\D)?[0-9]"
                            onKeyDown={event => onKeyDownEnter(event)}
                        />
                        <Form.Control hidden readOnly name='cuit' value={cuitValue} ref={register()} />
                        <FormFieldError errors={errors?.cuit} />
                    </Col>
                </Form.Group>

                <Form.Group as={Row}>
                    <Form.Label className='text-right d-flex mandatory-label' column sm='4'>
                        <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
                        Denominación:
                    </Form.Label>
                    <Col sm='4'>
                        <Form.Control
                            autoComplete="off"
                            type='text'
                            readOnly={personaFound || cuitDataIsFetching}
                            name='companyName'
                            value={companyNameValue}
                            placeholder='Denominación'
                            onChange={handleInputProveedor}
                            ref={register()}
                        />
                        <FormFieldError errors={errors?.companyName} />
                    </Col>
                    <Col sm={1} className='ml-0 pl-0 mt-2'>
                        {cuitDataIsFetching && <Spinner animation='border' size='sm' />}
                    </Col>
                </Form.Group>

                <Form.Group as={Row}>
                    <Form.Label className='text-right d-flex mandatory-label' column sm='4'>
                        <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
                        Importe:
                    </Form.Label>
                    <Col sm='4'>
                        <NumericFormat
                            className="form-control"
                            autoComplete="off"
                            type='text'
                            placeholder='Importe'
                            value={amountValue}
                            onChange={(event) => setAmountValue(event?.target?.value)}
                            prefix="$ "
                            thousandSeparator="."
                            decimalSeparator=","
                            decimalScale={2}
                            fixedDecimalScale={true}
                            allowNegative={false}
                            onKeyDown={event => onKeyDownEnter(event)}
                        />
                        <Form.Control hidden readOnly name='amount' value={amountValue} ref={register()} />
                        <FormFieldError errors={errors?.amount} />
                    </Col>
                </Form.Group>

                {(validarPersona || validatedPerson) &&
                    <Row>
                        <Col sm={4} className='offset-md-4'>
                            <Alert variant={msjValidacionColor} className='form-field-error mb-0 py-1 mt-2'>
                                {msjValidacion}
                            </Alert>
                        </Col>
                    </Row>
                }

                <Row className="mt-3">
                    <Col sm={4} className='offset-md-4'>
                        <Button
                            variant="primary"
                            onClick={addBeneficiary}
                            disabled={!cuitValue || !companyNameValue || !amountValue || cuitDataIsFetching}
                        >
                            <FontAwesomeIcon icon={faPlus} className="mr-2" />
                            Agregar Beneficiario
                        </Button>
                        {cuitValue && (
                            <Button
                                variant="link"
                                className="text-danger ml-2"
                                onClick={clearBeneficiarioForm}
                            >
                                <FontAwesomeIcon icon={faTimes} className="mr-1" />
                                Limpiar
                            </Button>
                        )}
                    </Col>
                </Row>
            </Card.Body>
        </Card>

        {beneficiaries.length > 0 && (
            <Card>
                <Card.Header>
                    <FontAwesomeIcon icon={faUsers} className="mr-2" />
                    Beneficiarios ({beneficiaries.length})
                </Card.Header>
                <Card.Body className="p-0">
                    <Table striped hover className="mb-0">
                        <thead>
                            <tr>
                                <th className="text-center align-middle">CUIT</th>
                                <th className="text-center align-middle">Denominación</th>
                                <th className="text-center align-middle">Importe</th>
                                <th className="text-center align-middle">Validación</th>
                                <th className="text-center align-middle">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {beneficiaries.map((beneficiary, index) => (
                                <tr key={index}>
                                    <td className="text-center align-middle">{beneficiary?.cuitFormatted}</td>
                                    <td className="text-center align-middle">
                                        {beneficiary?.companyName}
                                        {beneficiary?.providerNumber && (
                                            <small className="d-block text-muted">
                                                Proveedor N°: {beneficiary?.providerNumber}
                                            </small>
                                        )}
                                    </td>
                                    <td className="text-right align-middle">{beneficiary?.amountFormatted}</td>
                                    <td className="text-center align-middle">
                                        {beneficiary?.beneficiaryValidator && (
                                            <small className="text-muted">{beneficiary?.beneficiaryValidator}</small>
                                        )}
                                    </td>
                                    <td className="text-center align-middle">
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            onClick={() => removeBeneficiary(index)}
                                        >
                                            <FontAwesomeIcon icon={faTimes} className="mr-1" />
                                            Quitar
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        )}

        {beneficiaries.length > 0 && (
            <Card className="mt-3 mb-3">
                <Card.Body className="text-right">
                    <h6 className="mb-0">
                        <span>Importe Total Beneficiarios: </span>
                        <span className="text-primary">
                            $ {beneficiaries.reduce((sum, b) => sum + (b.subsidyAmount || 0), 0)
                                .toFixed(2)
                                .replace('.', ',')
                                .replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                        </span>
                    </h6>
                </Card.Body>
            </Card>
        )}
        <BeneficiariesAmountValidationComponent
            beneficiaries={beneficiaries}
            totalAmountBeneficiaries={totalAmountBeneficiaries}
            importe={importe}
            selectedExpedientAssociated={selectedExpedientAssociated}
            expedientesSeleccionados={expedientesSeleccionados}
            isValidTotalAmountBeneficiaries={isValidTotalAmountBeneficiaries}
        />
        <FormFieldError errors={errors?.beneficiaries} />
    </>
}

export default SubsidiesForm;